const isServer = typeof window === 'undefined';

let exp;

if (isServer) {
    exp = eval('require("../../server/modules/backbone-relational-server")');
} else {
    exp = require('backbone-relational');
}

export default exp;
